import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("polling");
  const [data, setData] = useState(null);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }

    let attempts = 0;
    const poll = async () => {
      if (attempts >= 6) { setStatus("timeout"); return; }
      attempts++;
      try {
        const { data } = await api.get(`/transactions/stripe/status/${sessionId}`);
        setData(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] text-slate-900 px-6" data-testid="payment-return-page">
      <div className="sk-card p-10 max-w-md w-full text-center">
        {status === "polling" && (
          <>
            <Loader2 className="w-10 h-10 text-[#00D533] mx-auto animate-spin" />
            <h2 className="font-heading text-2xl mt-4">Confirming payment</h2>
            <p className="text-slate-500 mt-2">Polling Stripe for status...</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-[#00D533] mx-auto" />
            <h2 className="font-heading text-2xl mt-4" data-testid="payment-success-msg">Payment confirmed</h2>
            <p className="text-slate-500 mt-2">${(data?.amount_total / 100 || 0).toFixed(2)} {data?.currency?.toUpperCase()}</p>
            <Button className="mt-6 bg-[#00D533] hover:bg-[#00E636] text-black font-semibold" onClick={() => navigate("/dashboard/transactions")} data-testid="payment-back-btn">
              Back to transactions
            </Button>
          </>
        )}
        {(status === "expired" || status === "timeout" || status === "error") && (
          <>
            <XCircle className="w-12 h-12 text-[#FF4757] mx-auto" />
            <h2 className="font-heading text-2xl mt-4">Payment incomplete</h2>
            <p className="text-slate-500 mt-2">Session expired or could not be confirmed. Please try again.</p>
            <Button className="mt-6 bg-[#00D533] hover:bg-[#00E636] text-black font-semibold" onClick={() => navigate("/dashboard/transactions/new")}>
              Try again
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
